module.exports = __webpack_public_path__ + "img/photo-0014.b0e34a8b.jpg";